export const REVIEW_TIME_FRAME_OPTIONS = [
  { label: '1st Day', code: '1_DAY' },
  { label: '2nd Day', code: '2_DAY' },
  { label: '1 Month', code: '1_MONTH' },
  { label: '2 Months', code: '2_MONTH' },
  { label: '3 Months', code: '3_MONTH' },
  { label: '1st Year', code: '1_YEAR' },
  { label: '2nd Year', code: '2_YEAR' },
  { label: '3rd Year', code: '3_YEAR' },
  { label: '4th Year', code: '4_YEAR' },
  { label: '5th Year', code: '5_YEAR' },
  { label: 'Last Day', code: 'LAST_DAY' },
  { label: 'With Result', code: 'WITH_RESULT' },
];

export const REVIEW_TIME_FRAME_LABELS = Object.fromEntries(
  REVIEW_TIME_FRAME_OPTIONS.map(({ label, code }) => [code, label]),
);

export const getReviewTimeFrameLabel = (review) =>
  REVIEW_TIME_FRAME_LABELS[review.time_frame_code] ?? review.timeframe_label ?? '';
